<template>
    <hts-drawer
        v-model="visible"
        color="main"
        size="large"
        :title="$t('labels.viewInvoice')"
        @close="close">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <hts-form-input
                v-model="formData.customerName"
                :label="$t('labels.customer')"
                readonly />

            <hts-select-cooperator-invoicing-information
                v-model="formData.selectInvoicingInformation"
                v-model:name="formData.selectInvoicingInformationName"
                :disabled="!formData.customerId"
                :cooperator-id="formData.customerId"
                :label="$t('labels.selectInvoicingInformation')"
                :creatable="true"
                prop="contact"
                name-select="contact"
                readonly />

            <hts-form-date
                v-model="formData.invoicedDate"
                :label="$t('labels.invoicedDate')"
                readonly />

            <hts-form-date
                v-model="formData.dueDate"
                :label="$t('labels.dueDate')"
                readonly />

            <hts-form-select
                v-model="formData.currency"
                :items="currencyOptions"
                :label="$t('labels.currency')"
                readonly />

            <hts-form-select
                v-model="formData.paymentMethod"
                :items="paymentMethodOptions"
                :label="$t('labels.paymentMethod')"
                readonly />

            <hts-select-bank-account
                v-if="formData.paymentMethod === 'bank'"
                v-model="formData.bankAccountId"
                v-model:name="formData.bankAccountInfo"
                creatable
                readonly />
        </div>

        <div class="mt-5">
            <div class="hidden md:grid grid-cols-4 gap-2 p-2 font-medium border-b bg-gray-100">
                <div>
                    Loại phí
                </div>
                <div>
                    Tên phí
                </div>
                <div>
                    {{ $t('labels.currency') }}
                </div>
                <div>
                    {{ $t('labels.price') }}
                </div>
            </div>

            <template
                v-for="(price, index) in formData.prices"
                :key="index">
                <!-- Desktop Row -->
                <div class="hidden md:grid grid-cols-4 gap-2 p-2 border-b items-center">
                    <div>
                        <hts-form-input
                            v-model="price.chargeTypeNane"
                            readonly />
                    </div>
                    <div>
                        <hts-tooltip reference-class="truncate">
                            <span>
                                {{ price.priceName }}
                            </span>
                            <template #reference>
                                <span class="truncate">
                                    {{ price.priceName }}
                                </span>
                            </template>
                        </hts-tooltip>
                    </div>
                    <div>
                        {{ price.currency }}
                    </div>
                    <div>
                        <hts-form-input
                            v-model="price.amount"
                            readonly />
                    </div>
                </div>
            </template>

            <div class="border-t mt-4 pt-4 flex justify-end">
                <div class="grid grid-cols-3 gap-y-2 w-full max-w-md text-right">
                    <div class="font-semibold text-left">
                        Tổng
                    </div>
                    <div class="font-semibold">
                        {{ formData.currency }}
                    </div>
                    <div class="font-semibold">
                        {{ $formatters.formatCurrency(totalAmount, 0) }}
                    </div>
                </div>
            </div>
        </div>
    </hts-drawer>
</template>
<script setup lang="ts">
const visible = ref<boolean>(false)
const emits = defineEmits(['refreshTables'])
const formData = ref({
  recipientFrom: '',
  customerId: '',
  customerName: '',
  selectInvoicingInformation: '',
  selectInvoicingInformationName: '',
  invoicedDate: '',
  dueDate: '',
  currency: 'VND',
  paymentMethod: '',
  prices: [] as { [key: string]: any }[],
  bankAccountId: '',
  bankAccountInfo: ''
})

const resetForm = () => {
  formData.value = {
    recipientFrom: 'CUSTOMER',
    customerId: '',
    customerName: '',
    selectInvoicingInformation: '',
    selectInvoicingInformationName: '',
    invoicedDate: '',
    dueDate: '',
    currency: 'VND',
    paymentMethod: '',
    prices: [] as { [key: string]: any }[],
    bankAccountId: '',
    bankAccountInfo: ''
  }
}

const tripId = ref('')

const open = (tripId: string, invoiceId: string) => {
  visible.value = true
  getData(tripId, invoiceId)
}
const getData = async (tripId: string, invoiceId: string) => {
  const api = {
    url: `/trip/${tripId}/billing-and-costing/invoice/${invoiceId}`,
    method: 'get'
  }
  const data: any = await $api(api)
  const resData: any = data.data.value

  if (resData?.success) {
    formData.value = resData.data
  }
}

const currencyOptions = [{ label: 'VND', value: 'VND' }]

const totalAmount = computed(() => {
  return $lodash.sumBy(formData.value.prices, 'amount') || 0
})

const paymentMethodOptions = [
  { label: 'Tiền mặt', value: 'cash' },
  { label: 'Chuyển khoản', value: 'bank' }
]

const close = () => {
  resetForm()
  visible.value = false
}

defineExpose({ open })
</script>
